/**
 * 数据上报工具
 */
import { getCurrentShopData, getCurrentUser } from "@/utils/storage";
import { TrackingSDK } from "@yishou/yishou-tracking-sdk";

const opts = {
  host: "cn-shenzhen.log.aliyuncs.com", // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
  project: TRACKER_PROJECT, // Project名称
  logstore: "h5_log", // Logstore名称
  time: 2, // 发送日志的时间间隔，默认是10秒。
  count: 5, // 发送日志的数量大小，默认是10条。
};

/**
 * 日志上报
 * @param topic 事件名，一般event与其对应
 * @param activity 事件行为显示名称，中文
 * @param data 事件数据，如 { click_source: '首页' }
 */
export const sendLog = (
  topic: string,
  activity: string,
  data: Record<string, unknown>,
) => {
  const currentUser = getCurrentUser();
  if (!currentUser?.userId) {
    return;
  }
  const currentShop = getCurrentShopData();
  const combineData = {
    uid: currentUser.userId,
    supply_id: currentShop.supplierId,
    store_id: currentShop.shopId,
    event: topic,
    time: new Date().getTime(),
    source: location.href,
    ...data,
  };
  const trackerData = {
    activity: activity,
    ...combineData,
  };
  const tracker = new TrackingSDK({ ...opts, topic });
  tracker.send(trackerData);
};
